import React, { useEffect, useRef, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Loader2, X } from "lucide-react";
import { toast } from "sonner";
import { api } from "../lib/api";

export default function ActiveScanPill() {
  const [job, setJob] = useState(null);
  const [confirming, setConfirming] = useState(false);
  const confirmTimer = useRef(null);
  const location = useLocation();

  useEffect(() => {
    const fetchActive = () =>
      api.get("/videos/active").then((res) => setJob(res.data.job)).catch(() => {});
    fetchActive();
    const interval = setInterval(fetchActive, 10000);
    return () => clearInterval(interval);
  }, [location.pathname]);

  useEffect(() => () => clearTimeout(confirmTimer.current), []);

  if (!job) return null;

  const cancelScan = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (!confirming) {
      setConfirming(true);
      confirmTimer.current = setTimeout(() => setConfirming(false), 4000);
      return;
    }
    clearTimeout(confirmTimer.current);
    try {
      await api.post(`/videos/${job.id}/cancel`);
      setJob(null);
      setConfirming(false);
      toast.success("Scan cancelled — cards already priced are kept in your binder");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Couldn't cancel the scan");
    }
  };

  const label = job.total_cards_detected
    ? `${job.cards_processed || 0}/${job.total_cards_detected}`
    : "…";

  return (
    <Link
      to={`/review/${job.id}`}
      data-testid="navbar-active-scan-pill"
      title="A scan is running — tap to watch cards roll in"
      className="flex items-center gap-1.5 text-xs px-3 py-1 rounded-full border border-[#A78BFA]/40 bg-[#A78BFA]/10 text-[#A78BFA] hover:bg-[#A78BFA]/20 transition-colors"
    >
      <Loader2 className="w-3 h-3 animate-spin" />
      <span className="font-semibold">Scanning {label}</span>
      <button
        data-testid="active-scan-cancel-button"
        onClick={cancelScan}
        title={confirming ? "Click again to stop this scan" : "Cancel this scan"}
        className={`flex items-center rounded-full transition-colors ${confirming ? "text-red-400 bg-red-500/15 px-1.5 py-0.5 text-[10px] font-semibold" : "text-[#A78BFA]/70 hover:text-red-400 p-0.5"}`}
      >
        {confirming ? "Stop?" : <X className="w-3 h-3" />}
      </button>
    </Link>
  );
}
